/**
 * Senior Advisors — shared data source.
 *
 * Consumed by:
 *  · pages/AdvisorsPage.jsx (dedicated /advisors page · full bios)
 *  · pages/TeamPage.jsx (compact card grid on /team)
 *  · components/landing/SeniorAdvisors.jsx (homepage block)
 */
export const SENIOR_ADVISORS = [
  {
    id: "alistair-wood",
    name: "Alistair Wood",
    role: "Senior Advisor",
    qualifier: "Corporate Banking & Syndicated Credit",
    pillars: [
      { label: "Career", value: "HSBC · Midland" },
      { label: "Geography", value: "UK · Japan · Australia" },
      { label: "Last Role", value: "State Manager NSW, HSBC" },
    ],
    bio: [
      "Alistair Wood holds a Bachelor of Science degree in Banking and Finance from Loughborough University. Sponsored through university by Midland Bank, Alistair joined the firm upon graduation and pursued a career in corporate banking and risk management through a variety of roles with HSBC following its acquisition of Midland.",
      "His career has spanned the United Kingdom, Japan and Australia. In 2007, Alistair was appointed State Manager, New South Wales for HSBC Australia's Commercial Banking operations, where he successfully led a growing team to more than triple revenues over a five-year period.",
      "Alistair brings extensive experience across bi-lateral, club and syndicated facilities — engaging private and public companies, domestic and multinational corporates, in both mid-market and large segments. At Kellermann Reid & Co., he engages with the partnership on a non-executive, episodic basis as a Senior Advisor — contributing corporate-banking and syndicated-credit pattern recognition to underwriting and portfolio engagement.",
    ],
    short:
      "Former State Manager NSW, HSBC Australia Commercial Banking. Career across UK, Japan and Australia in corporate banking, syndicated credit and risk management at HSBC and Midland Bank.",
    linkedin: "https://www.linkedin.com/in/alistair-wood-345491b/",
    photo: "/portraits/alistair-wood.jpg",
  },
  {
    id: "angelo-barbati",
    name: "Angelo Barbati",
    role: "Senior Advisor",
    qualifier: "Debt Structuring & Risk",
    pillars: [
      { label: "Career", value: "HSBC · ANZ · Banca MPS" },
      { label: "Tenure", value: "25+ years" },
      { label: "Last Role", value: "Senior Manager MME, HSBC" },
    ],
    bio: [
      "Angelo Barbati holds a Bachelor of Economics (Accounting and Economics majors) from Macquarie University. Angelo has spent more than 25 years in the banking industry, holding a range of management and senior management roles across business and corporate banking and risk management.",
      "His career spans both the domestic and international banking sector, including ANZ, Banca Monte Paschi and most recently eleven years at HSBC Bank Australia. His last role at HSBC was as Senior Manager, Middle Market Enterprises for the Commercial Banking operations.",
      "Angelo brings extensive experience in debt structuring, trade finance, treasury services and cash-flow lending — across private and public, domestic and multinational corporates in the mid-market space. At Kellermann Reid & Co., he engages with the partnership on a non-executive, episodic basis as a Senior Advisor — contributing debt-structuring and credit-risk depth to underwriting and portfolio engagement.",
    ],
    short:
      "Former Senior Manager, Middle Market Enterprises, HSBC Bank Australia. Twenty-five years across debt structuring, trade finance, treasury and credit risk at HSBC, ANZ and Banca Monte Paschi.",
    linkedin: "https://www.linkedin.com/in/angelo-barbati-0bb4387a/",
    photo: "/portraits/angelo-barbati.jpg",
  },
];
